import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faNotes } from '@fortawesome/pro-solid-svg-icons';
import {
  ConstitutionSnapshot,
  SectionKey,
  SocioSnapshot,
  SerieSnapshot,
  MiembroAdminSnapshot,
  ApoderadoSnapshot,
} from '../models/constitution-snapshot.model';
import { ConstitutionSociosReadonlyTableComponent } from './socios/constitution-socios-readonly-table.component';
import { ConstitutionSociosReadonlyDetailComponent } from './socios/constitution-socios-readonly-detail.component';
import { ConstitutionAdministrationReadonlyTableComponent } from './administration/constitution-administration-readonly-table.component';
import { ConstitutionAdministrationReadonlyDetailComponent } from './administration/constitution-administration-readonly-detail.component';
import { ConstitutionAttorneysReadonlyTableComponent } from './attorneys/constitution-attorneys-readonly-table.component';
import { ConstitutionAttorneysReadonlyDetailComponent } from './attorneys/constitution-attorneys-readonly-detail.component';
import { ConstitutionReadonlyFieldComponent } from './shared/constitution-readonly-field.component';
import { formatShareAmountEs } from '../../constitution-form/utils/format-share-amount';
import { formatEuro, totalCapitalSocialEuro } from '../../constitution-form/utils/socios-display.util';

type DetailModal =
  | { type: 'socio'; data: SocioSnapshot }
  | { type: 'serie'; data: SerieSnapshot }
  | { type: 'miembro'; data: MiembroAdminSnapshot }
  | { type: 'apoderado'; data: ApoderadoSnapshot }
  | null;

@Component({
  selector: 'app-constitution-readonly',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    ConstitutionSociosReadonlyTableComponent,
    ConstitutionSociosReadonlyDetailComponent,
    ConstitutionAdministrationReadonlyTableComponent,
    ConstitutionAdministrationReadonlyDetailComponent,
    ConstitutionAttorneysReadonlyTableComponent,
    ConstitutionAttorneysReadonlyDetailComponent,
    ConstitutionReadonlyFieldComponent,
  ],
  templateUrl: './constitution-readonly.component.html',
  styleUrls: [
    './constitution-readonly.component.scss',
    '../../constitution-form/constitution-form.component.scss',
  ],
})
export class ConstitutionReadonlyComponent {
  readonly faNotes = faNotes;
  readonly formatShareAmount = formatShareAmountEs;
  readonly formatEuro = formatEuro;
  readonly totalCapitalSocialEuro = totalCapitalSocialEuro;

  @Input() sociosParcial: string | null = null;
  @Input() data: ConstitutionSnapshot | null = null;
  /** When provided, only the listed sections are rendered. null/undefined = show all. */
  @Input() sections: SectionKey[] | null = null;

  shows(s: SectionKey): boolean {
    return !this.sections || this.sections.includes(s);
  }

  selectedDetail = signal<DetailModal>(null);

  openDetail(d: DetailModal): void {
    this.selectedDetail.set(d);
  }

  closeDetail(): void {
    this.selectedDetail.set(null);
  }

  onSocioSelected(socio: SocioSnapshot): void {
    this.openDetail({ type: 'socio', data: socio });
  }

  onMemberSelected(miembro: MiembroAdminSnapshot): void {
    this.openDetail({ type: 'miembro', data: miembro });
  }

  onAttorneySelected(apoderado: ApoderadoSnapshot): void {
    this.openDetail({ type: 'apoderado', data: apoderado });
  }

  formatNominal(value: number | null | undefined): string {
    if (value == null) return '—';
    return formatEuro(value);
  }

  formatNumeracion(desde?: number, hasta?: number): string {
    const d = desde != null ? formatShareAmountEs(desde) : '';
    const h = hasta != null ? formatShareAmountEs(hasta) : '';
    if (!d && !h) return '—';
    return `${d} — ${h}`;
  }
}
